import * as React from "react";
import VariableList from "./variable-list";

class Index extends React.Component<{}, {}> {
    render = () => {
        return (
            <VariableList />
        );
    }
}

export default Index;